module.exports = __webpack_public_path__ + "step4.ee3fdeef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4.png
// module id = wobW
// module chunks = 0